import React from 'react'

import { useCurrentSurveyGroupIdState } from '~/hooks/useCurrentSurveyGroupIdState'
import { exists, findByPath } from '~/utils'

import { useCurrentBrandAccountSurveyGroupsQueryData } from './useCurrentBrandAccountSurveyGroupsQuery'

export const useCurrentSurveyGroup = () => {
  const [surveyGroupId] = useCurrentSurveyGroupIdState()
  const surveyGroups = useCurrentBrandAccountSurveyGroupsQueryData()

  return React.useMemo(() => {
    if (!exists(surveyGroupId)) {
      return undefined
    }

    return findByPath(surveyGroups, 'id', surveyGroupId)
  }, [surveyGroupId, surveyGroups])
}
